import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import { computed } from 'vue';
import { guid } from 'shared/lib/uuid';
import { iconByType } from '@/lib/property';
import { propertyType, userScopeType } from 'shared/constants.json';
import { textByLang } from 'shared/lib/language';
import { useI18n } from 'vue-i18n';

export default function useScopeItems(props, showStaticUserSelection, multiModel) {
  const { t } = useI18n();
  const { userLang } = useLoggedInUser();

  const staticUserItem = {
    value: guid(),
    icon: 'user',
    text: t('userScope.staticUserLabel'),
    type: userScopeType.staticUsers,
  };

  const allowedProps = computed(() => {
    const notAllowed = [
      propertyType.text,
      propertyType.url,
      propertyType.richText,
    ];

    return props.value.filter((p) => !notAllowed.includes(p.property.type));
  });

  const scopeItemByProp = (prop) => {
    const getKey = (key, property) => (multiModel ? `${property.model}-${key}` : key);
    const getPropText = (property) => (property.label === undefined ? '' : textByLang(property.label, userLang));
    const scopeItemByProperty = (property) => ({
      value: getKey(property.uid, property),
      text: getPropText(property),
      icon: iconByType(property),
      type: userScopeType.property,
      property,
    });
    const scopeItemByDirectProperty = (property) => ({
      value: getKey(property.edgeName, property),
      text: property.label,
      icon: iconByType({ type: property.type, edgeName: property.edgeName }),
      type: userScopeType.directProperty,
      directProperty: property,
    });

    if (prop.isDirect) {
      return scopeItemByDirectProperty(prop.property);
    }
    return scopeItemByProperty(prop.property);
  };

  const scopeItems = computed(() => {
    const items = allowedProps.value.map((p) => (scopeItemByProp(p)));
    if (showStaticUserSelection) {
      items.push(staticUserItem);
    }
    return items;
  });

  return {
    staticUserItem,
    scopeItems,
    scopeItemByProp,
  };
}
